/* eslint-disable prettier/prettier */
import { lazy } from 'react';
import Loadable from '../components/Loadable';

const screenMap = {
  // master
  '/access': Loadable(lazy(() => import('../pages/master/Access'))),
  '/employee': Loadable(lazy(() => import('../pages/master/Employee'))),
  '/role': Loadable(lazy(() => import('../pages/master/Role'))),
  '/category': Loadable(lazy(() => import('../pages/master/Category'))),
  '/bom': Loadable(lazy(() => import('../pages/master/Bom'))),
  '/logbook': Loadable(lazy(() => import('../pages/master/LogBook'))),
  '/rack': Loadable(lazy(() => import('../pages/master/Rack'))),
  '/shop': Loadable(lazy(() => import('../pages/master/Shop'))),
  '/taxmaster': Loadable(lazy(() => import('../pages/master/Taxmaster'))),
  '/todo': Loadable(lazy(() => import('../pages/master/Todo'))),
  '/party': Loadable(lazy(() => import('../pages/master/Party'))),
  '/widget': Loadable(lazy(() => import('../pages/master/Widget'))),
  '/user': Loadable(lazy(() => import('../pages/master/User'))),
  '/product': Loadable(lazy(() => import('../pages/master/Product'))),
  '/definelayout': Loadable(lazy(() => import('../pages/master/DefineLayout'))),
  '/section': Loadable(lazy(() => import('../pages/master/Section'))),
  '/barcode': Loadable(lazy(() => import('../pages/master/Barcode'))),
  '/brand': Loadable(lazy(() => import('../pages/master/Brand'))),
  '/org': Loadable(lazy(() => import('../pages/master/CompanyProfile'))),
  '/dynafields': Loadable(lazy(() => import('../pages/master/Dynafields'))),
  '/comboitems': Loadable(lazy(() => import('../pages/master/ComboItems'))),
  '/division': Loadable(lazy(() => import('../pages/master/Division'))),
  '/itemtax': Loadable(lazy(() => import('../pages/master/ItemTax'))),
  '/ledger': Loadable(lazy(() => import('../pages/master/Ledger'))),
  '/holiday': Loadable(lazy(() => import('../pages/master/HolidayPage'))),
  '/divlocation': Loadable(lazy(() => import('../pages/master/DivLocation'))),
  '/paystructure': Loadable(lazy(() => import('../pages/master/PayStructure'))),
  '/payroll': Loadable(lazy(() => import('../pages/master/PayRoll'))),
  '/paysliphist': Loadable(lazy(() => import('../pages/master/PayslipHist'))),
  '/shift': Loadable(lazy(() => import('../pages/master/Shift'))),
  '/teamsture': Loadable(lazy(() => import('../pages/master/Teamsture'))),
  '/assets': Loadable(lazy(() => import('../pages/master/Assets'))),
  '/assetstype': Loadable(lazy(() => import('../pages/master/Assetstype'))),
  '/shiftmaster': Loadable(lazy(() => import('../pages/master/ShiftMaster'))),
  '/skilltype': Loadable(lazy(() => import('../pages/master/SkillType'))),
  '/skilllevel': Loadable(lazy(() => import('../pages/master/SkillLevel'))),
  '/survey': Loadable(lazy(() => import('../pages/master/Survey'))),
  '/surveymaster': Loadable(lazy(() => import('../pages/master/SurveyMaster'))),

  '/gatepass': Loadable(lazy(() => import('../pages/master/Gatepass'))),
  '/enquiry': Loadable(lazy(() => import('../pages/master/Enquiry'))),
  '/visitorlog': Loadable(lazy(() => import('../pages/master/VisitorLog'))),
  '/complaint': Loadable(lazy(() => import('../pages/master/Complaint'))),

  '/dropdowns': Loadable(lazy(() => import('../pages/master/Dropdown'))),

  //Kitchen
  '/billing': Loadable(lazy(() => import('../pages/kot/Billing'))),
  '/kothistory': Loadable(lazy(() => import('../pages/kot/KOTHistory'))),
  '/reprintkot': Loadable(lazy(() => import('../pages/kot/ReprintKOT'))),

  //Sales
  '/salebill': Loadable(lazy(() => import('../pages/sales/salebill/SaleBill'))),
  '/salebillb2b': Loadable(lazy(() => import('../pages/sales/salebillb2b/SaleBillB2B'))),
  '/servicebill': Loadable(lazy(() => import('../pages/sales/servicebill/ServiceBill'))),
  '/salehistory': Loadable(lazy(() => import('../pages/outwardview/OutwardView'))),
  '/stockcheck': Loadable(lazy(() => import('../pages/sales/stockcheck/StockCheck'))),
  '/stockcheckview': Loadable(lazy(() => import('../pages/sales/stockcheck/StockCheckView'))),
  '/stocktransfer': Loadable(lazy(() => import('../pages/sales/stocktransfer/StockTransfer'))),
  '/stocktransferview': Loadable(lazy(() => import('../pages/sales/stocktransfer/StockTransferView'))),
  '/excessshortage': Loadable(lazy(() => import('../pages/sales/excessshortageentry/ExcessShortageEntry'))),
  '/quotation': Loadable(lazy(() => import('../pages/sales/contract/Quotation'))),
  '/saleorder': Loadable(lazy(() => import('../pages/sales/contract/SaleOrder'))),
  '/dayjournal': Loadable(lazy(() => import('../pages/sales/dayjournal/DayJournal'))),
  '/quotationhistory': Loadable(lazy(() => import('../pages/sales/contract/history/QuotationHistory'))),
  '/saleorderhistory': Loadable(lazy(() => import('../pages/sales/contract/history/SaleOrderHistory'))),
  '/dayjournalhistory': Loadable(lazy(() => import('../pages/sales/dayjournal/DayJournalHistory'))),
  '/departmenttransfer': Loadable(lazy(() => import('../pages/sales/departmenttransfer/DepartmentTransfer'))),
  //marketplace
  '/marketplace': Loadable(lazy(() => import('../pages/marketplace/MarketPlace'))),

  //ratemanager
  '/ratemanager': Loadable(lazy(() => import('../pages/ratemanager/RateManager'))),

  //accounts
  '/tradingaccount': Loadable(lazy(() => import('../pages/accounts/TradingAccount'))),
  '/profitandloss': Loadable(lazy(() => import('../pages/accounts/ProfitAndLoss'))),
  '/balancesheet': Loadable(lazy(() => import('../pages/accounts/BalanceSheet'))),
  '/ledgersummary': Loadable(lazy(() => import('../pages/accounts/LedgerSummary'))),
  '/daybook': Loadable(lazy(() => import('../pages/accounts/DayBook'))),
  //accounts--financial
  '/trialbalance': Loadable(lazy(() => import('../pages/accounts/financialreports/TrialBalance'))),
  '/generalledger': Loadable(lazy(() => import('../pages/accounts/financialreports/GeneralLedger'))),
  '/receiptandpayment': Loadable(lazy(() => import('../pages/accounts/financialreports/ReceiptAndPayment'))),
  //cashbook
  '/cashbook': Loadable(lazy(() => import('../pages/accounts/cashbook/CashBook'))),
  '/simplecashbook': Loadable(lazy(() => import('../pages/accounts/cashbook/SimpleCashbook'))),
  //supplier
  '/supplierpayment': Loadable(lazy(() => import('../pages/supplierpayment/SupplierPayment'))),
  //gst invoice
  '/gstinvoice': Loadable(lazy(() => import('../pages/gstinvoice/GSTInvoice'))),

  //stock reports
  '/consumptionreports': Loadable(lazy(() => import('../pages/stockreports/ConsumptionReports'))),
  '/stockreportsbtwdates': Loadable(lazy(() => import('../pages/stockreports/StockReportBtwDates'))),

  //Inventory
  '/indenthistory': Loadable(lazy(() => import('../pages/production/IndentHistory'))),
  '/requesttostore': Loadable(lazy(() => import('../pages/production/RequestToStore'))),
  '/storeindent': Loadable(lazy(() => import('../pages/production/StoreIndent'))),
  '/receivefromdepartment': Loadable(lazy(() => import('../pages/production/ReceiveFromDepartment'))),
  '/receivefromstore': Loadable(lazy(() => import('../pages/production/ReceiveFromStore'))),
  '/production': Loadable(lazy(() => import('../pages/production/Production'))),
  '/productioninclusive': Loadable(lazy(() => import('../pages/production/ProductionInclusive'))),
  '/purchaseorder': Loadable(lazy(() => import('../pages/purchaseorder/PurchaseOrder'))),
  '/barcodeprint': Loadable(lazy(() => import('../pages/barcodeprint/BarcodePrint'))),

  '/dashboard': Loadable(lazy(() => import('../pages/dashboard/Dashboard'))),
  '/report': Loadable(lazy(() => import('../pages/reports/DynamicReports'))),

  // operations
  '/board': Loadable(lazy(() => import('../pages/projectGovernance/boardTransactions/Board'))),
  '/project': Loadable(lazy(() => import('../pages/master/Project'))),
  '/empbilling': Loadable(lazy(() => import('../pages/master/EmpBilling'))),
  '/team': Loadable(lazy(() => import('../pages/master/Team'))),
  '/windowusagelog': Loadable(lazy(() => import('../pages/projectGovernance/windowUsageLog/WindowUsageLog'))),
  '/listview': Loadable(lazy(() => import('../pages/projectGovernance/boardTransactions/TasksListView'))),
  '/timelineview': Loadable(lazy(() => import('../pages/projectGovernance/boardTransactions/TaskTimelineView'))),
  '/timesheet': Loadable(lazy(() => import('../pages/projectGovernance/boardTransactions/TimesheetTimeline'))),

  // hrm
  '/applyleave': Loadable(lazy(() => import('../pages/hrModule/ApplyLeave'))),
  '/approveleave': Loadable(lazy(() => import('../pages/hrModule/ApproveLeaveRequests'))),
  '/attendance': Loadable(lazy(() => import('../pages/hrModule/AttendanceScreen'))),
  '/applyexpense': Loadable(lazy(() => import('../pages/hrModule/ApplyExpense'))),
  '/approveexpense': Loadable(lazy(() => import('../pages/hrModule/ApproveExpense'))),
  '/payslip': Loadable(lazy(() => import('../pages/hrModule/PayslipManagement'))),
  '/feedback': Loadable(lazy(() => import('../pages/hrModule/AddConcern'))),
  '/approvefeedback': Loadable(lazy(() => import('../pages/hrModule/ApproveFeedback'))),
  '/advancesalaryapplied': Loadable(lazy(() => import('../pages/hrModule/AdvanceSalaryApply'))),
  '/advancesalaryapproved': Loadable(lazy(() => import('../pages/hrModule/ApproveAdvancesalary'))),
  '/position': Loadable(lazy(() => import('../pages/hrModule/Position'))),
  // goal sheet
  '/creategoalsheet': Loadable(lazy(() => import('../pages/hrModule/goalsheet/CreateGoalSheet'))),
  '/assigngoalsheet': Loadable(lazy(() => import('../pages/hrModule/goalsheet/AssignGoalSheet'))),
  '/employeeselfreview': Loadable(lazy(() => import('../pages/hrModule/goalsheet/EmployeeSelfReview'))),
  '/managerreview': Loadable(lazy(() => import('../pages/hrModule/goalsheet/ManagerReview'))),
  '/hikereport': Loadable(lazy(() => import('../pages/hrModule/goalsheet/HikeReport'))),

  // crm
  '/workflow': Loadable(lazy(() => import('../pages/crmModule/WorkflowTable'))),
  '/myassignments': Loadable(lazy(() => import('../pages/crmModule/Myassignments'))),
  '/allassignments': Loadable(lazy(() => import('../pages/crmModule/Allassignments'))),
  '/pipeline': Loadable(lazy(() => import('../pages/crmModule/PipelineView'))),
  '/todolist': Loadable(lazy(() => import('../pages/crmModule/AssignedUserTodoList'))),
  '/emailtemplates': Loadable(lazy(() => import('../pages/crmModule/Emailtemplatemanager'))),
  '/targets': Loadable(lazy(() => import('../pages/crmModule/TargetSetting'))),
  '/performance': Loadable(lazy(() => import('../pages/crmModule/TargetPerformnace'))),
  '/routeplanning': Loadable(lazy(() => import('../pages/crmModule/RoutePlanning'))),
  '/routeattendance': Loadable(lazy(() => import('../pages/crmModule/RouteAttendance'))),

  //Purchase
  '/purchase': Loadable(lazy(() => import('../pages/purchase/Purchase'))),
  '/stockreceipt': Loadable(lazy(() => import('../pages/purchase/StockReceipt'))),
  '/purchaseregister': Loadable(lazy(() => import('../pages/purchaseregister/PurchaseRegister'))),

  '/facility': Loadable(lazy(() => import('../pages/facility/FacilityMaster'))),
  '/facilityapproval': Loadable(lazy(() => import('../pages/facility/FacilityApprove'))),
  '/facilitybookings': Loadable(lazy(() => import('../pages/facility/Facilitybooking'))),
  '/visitorlogapproval': Loadable(lazy(() => import('../pages/master/ApproveVisitorLog'))),

  '/partyd': Loadable(lazy(() => import('../pages/dynmicpages/PartyMaster'))),
  '/employeed': Loadable(lazy(() => import('../pages/dynmicpages/EmployeeMaster'))),
  '/templatemaster': Loadable(lazy(() => import('../pages/dynmicpages/TemplateMaster'))),

   '/intervieweval': Loadable(lazy(() => import('../pages/hrModule/Interviewevaluation')))
};

const rawFunctions = localStorage.getItem('functionsData');
let SidebarRoutes = [];

if (rawFunctions) {
  try {
    const parsed = JSON.parse(rawFunctions);

    SidebarRoutes = parsed
      .map((fn) => {
        if (!fn || typeof fn.launch !== 'string' || !fn.launch.trim()) {
          return null;
        }

        const path = fn.launch.toLowerCase();

        let basePath = path;

        if (path.startsWith('/report/')) {
          basePath = '/report';
        } else if (path.startsWith('/dashboard/')) {
          basePath = '/dashboard';
        }

        const Component = screenMap[basePath];

        return Component
          ? {
              path: path.replace(/^\//, ''),
              element: <Component />
            }
          : null;
      })
      .filter(Boolean);
  } catch (err) {
    console.error('Failed to parse functions from localStorage:', err);
  }
}

export default SidebarRoutes;
